export const types = {
    USER_ADD: 'USER_ADD',
    USER_UPDATE: 'USER_UPDATE',
    USER_REMOVE: 'USER_REMOVE'
  }; 